import { render, staticRenderFns } from "./OfficeEdit.vue?vue&type=template&id=00005bdb&scoped=true&"
import script from "./OfficeEdit.vue?vue&type=script&lang=ts&"
export * from "./OfficeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeEdit.vue?vue&type=style&index=0&id=00005bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00005bdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VForm,VSpacer})
